/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from '../../helpers/graphQLShortcuts'
import {fieldObjectSectionStyleCss} from '../../helpers/createStyles';
import JobSearch from "./JobSearch";

interface Data {
    paragraphById: {
        fieldTitle: string;
        fieldObjectSectionStyle: Array<{entity: Array}>;
    }
}

class JobSearchGqlQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphJobSearch {
          fieldTitle
          fieldObjectSectionStyle {
              ${fieldObjectSectionStyle}
          }
        }
      }
    }
  }
}
`;

const JobSearchQuery = ({id, markComponentLoadedAs}) => (
    <JobSearchGqlQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            const styles = fieldObjectSectionStyleCss(field.fieldObjectSectionStyle);

            if (!styles.css.padding) {
                styles.css.padding = '80px 0px';
                styles.css.maxWidth = '1300px';
                styles.css.margin = '0 auto';
            }

            markComponentLoadedAs(id, true);

            return (
                <div className={`jobSearchOuter${styles.classNames}`} style={styles.css} id={styles.id}>
                    {styles.childBackground.isActive && (
                        <div className="jobSearchOuter__background" style={styles.childBackground.css}/>
                    )}
                    <div className="container">
                        <JobSearch title={field.fieldTitle}/>
                    </div>
                </div>
            );
        }}
    </JobSearchGqlQuery>
);

JobSearchQuery.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired
};

export default JobSearchQuery;



// WEBPACK FOOTER //
// ./frontend/components/Jobs/JobSearchQuery.jsx